





















import { Component, Mixins } from 'vue-property-decorator'

import { mainRoutes } from '@/router'
import { security } from '@/store/modules/security'
import { Geolocation } from '@/mixins/Geolocation'

@Component
class MainView extends Mixins<Geolocation>(Geolocation) {
  securityModule = security.context(this.$store)

  routes = mainRoutes

  get tabList() {
    if (this.securityModule.getters.isUserRoleFictive)
      return this.routes.filter(item => item.meta.hideFictive === false)
    else if (this.securityModule.getters.isUserRoleHolder)
      return this.routes.filter(item => item.meta.hideHolder === false)
    else if (this.securityModule.getters.isUserRoleChildren)
      return this.routes.filter(item => item.meta.hideChildren === false)
    else return []
  }

  get hideTabs() {
    return this.$route.meta?.hideTabs
  }
}

export default MainView
